import { Link } from 'expo-router';

import { Button, HStack, Icon } from '@squire/ui';

import { CloseButton } from '@/components/_shared/CloseButton';
import { MaxWidthWrapper } from '@/components/_shared/MaxWidthWrapper';
import { useAuthRedirect } from '@/hooks/auth/useAuthRedirect';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';

const SignupFlowHeader = ({
  hideBackButton = false,
}: {
  hideBackButton?: boolean;
}) => {
  const { t } = useScreenTranslations('AuthScreen');
  // Close returns to wherever auth was opened from (e.g. the booking/gift-card
  // sheet), same as a successful sign-in — not always home.
  const { redirectAfterAuth } = useAuthRedirect();

  return (
    <MaxWidthWrapper flex={false} style={styles.maxWidthWrapper}>
      <HStack style={styles.header}>
        <CloseButton
          testID="close-button"
          onPress={redirectAfterAuth}
          accessibilityLabel={t('accessibility.closeButton')}
          accessibilityHint={t('accessibility.closeButtonHint')}
        />

        {!hideBackButton && (
          <Link asChild testID="back-button" href="..">
            <Button
              variant="secondary"
              size="small"
              accessibilityRole="button"
              accessibilityLabel={t('accessibility.closeButton')}
              accessibilityHint={t('accessibility.closeButtonHint')}
            >
              <Icon name="chevronLeft" size={16} />
            </Button>
          </Link>
        )}
      </HStack>
    </MaxWidthWrapper>
  );
};

SignupFlowHeader.displayName = 'SignupFlowHeader';
export { SignupFlowHeader };
